import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddManageModuleMutation,useGetCourseListQuery} from "../../../Services/api";

export default function Create() {
    const validationSchema = Yup.object().shape({
        coursecode: Yup.string().required("course fields is required"),
        lesson_name: Yup.string().required("course name fields is required"),
    });
    
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [addManageModule,isLoading] = useAddManageModuleMutation();
    const onSubmit = (values,e) => {
        addManageModule({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Module</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                            <div className="col-sm-10">
                               <select  {...register("coursecode")} className="form-control" >
                                 <option value="">Select Course</option>                                           

                                {                            
                                getCourseList?.data?.map((item) => {
                                    return (
                                        <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                        )
                                    })
                                }
                                </select>
                                <span className="text-danger">{errors.coursecode?.message}</span>
                            </div>
                        </div>
                       
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Module Name</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("lesson_name")} className="form-control" />
                                <span className="text-danger">{errors.lesson_name?.message}</span>
                            </div>
                        </div>
                       
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                               {isLoading.status !='pending' ? 
                                                
                                <button type="submit" className="btn btn-warning w-100" >Add Module</button>
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}